import script from "./POSHome.vue?vue&type=script&setup=true&lang=js"
export * from "./POSHome.vue?vue&type=script&setup=true&lang=js"

import "./POSHome.vue?vue&type=style&index=0&id=20bb2fbb&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20bb2fbb"]])

export default __exports__